// components/ConfirmModal.jsx — modale de confirmation générique, partagée
// par toute l'appli. Remplace les window.confirm() natifs (bloquants, non
// stylables) — extraite de SuperAdminApp.jsx pour être réutilisable ailleurs
// (ex: TableOrdersPage.jsx) sans duplication.
export default function ConfirmModal({ title, message, confirmLabel, danger, loading, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && !loading && onCancel()}>
      <div className="modal" style={{ maxWidth: 420 }}>
        <h3 style={{ marginTop: 0 }}>{title}</h3>
        <p style={{ color: 'var(--text-3)', fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-line' }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button className="btn btn-secondary" style={{ flex: 1, justifyContent: 'center' }}
            onClick={onCancel} disabled={loading}>
            Annuler
          </button>
          <button
            onClick={onConfirm} disabled={loading}
            style={{ flex: 1, padding: '10px 16px', borderRadius: 10, border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', fontSize: 14, fontWeight: 700,
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
              background: danger ? '#ff4d6d' : '#7c5cfc', color: '#fff', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Un instant…' : (confirmLabel || 'Confirmer')}
          </button>
        </div>
      </div>
    </div>
  );
}
